import { MpsAuthService, MpsUserService } from '../../../../../mps/mps-auth';
import { Component, OnInit, Input } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import {TranslateService} from '@ngx-translate/core';
import {User} from 'src/app/models/user';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    authUser: User;
    
    
  @Input() public nav: MatSidenav;
  constructor(
	public userService: MpsUserService,
	public authService: MpsAuthService,
	public translateService: TranslateService,
  ) {
  }
  
  get currentLang(): string {
    return this.translateService.currentLang;
  }
  
  set currentLang(lang:string) {
    this.setCurrentLang(lang);
  }
  
  setCurrentLang(lang: string) {
    this.translateService.use(lang);
    this.translateService.currentLang = lang;
    window.localStorage.setItem('sccp_lang', lang);
  }

  ngOnInit() {
        this.authUser = new User(this.userService.getUser().getValue());
        let lang = window.localStorage.getItem('sccp_lang');
        if (lang != undefined) {
            this.setCurrentLang(lang);
        } else {
            this.setCurrentLang('en');
        }
  }
  
  updateLang(lang: string): void {
    if (this.authService.isLoggedIn().getValue()) {
      //this.crudService.updateUserLang(lang).subscribe(user => {
        //this.userService.getUser().next(user);
        this.setCurrentLang(lang);
      //});
    }
  }

  /*updateLang(lang: string) {
	this.translateService.use(lang);
  }*/
}
